import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Header from '../components/Header';
import '../style/Product.css';
import Sidebar from '../components/Sidebar';
import { db, auth } from '../firebase';
import axios from 'axios';

 
  const products = [
    
    {
      id: 1,
      name: 'White Oversized T-shirt',
      title: 'whot',
      images: ['190GSMWhite.jpg', '190GSMWhiteB.jpg'],
      description: 'White Oversized T-shirt',
      fabric: '100% Cotton',
      BASE_COST: 235,
      tax: 'tax',
      mockups: ['190GSMWhite.jpg', '190GSMWhiteB.jpg'],
      texture: '21.png',
      GSM: '190 GSM',
      costStructure: {
        'DTG': {
          logo: 36,
          LessthenA4: 66,
          A4less: 102,
          A4: 90,
          A3: 120,
         full: 150,
        },
        'DTF': {
          logo: 36,
          LessthenA4: 66,
          A4less: 102,
          A4: 90,
          A3: 120,
         full: 150,
        },
      },

      clippingRects: {
        front: { left: 540, top: 690, width: 1120, height: 1400 },
        back: { left: 540, top: 690, width: 1120, height: 1400 }
      },

      print_method: ["DTG", "DTF"],
      sizeChart:'190-regular.jpg',
      sizes : ['S', 'M', 'L', 'XL', 'XXL']
    },
    
    
    {
      id: 2,
      name: 'White Oversized T-shirt',
      title: 'whot',
      images: ['220GSMWhite.jpg', '220GSMWhiteB.jpg'],
      description: 'White Oversized T-shirt',
      fabric: '100% Cotton',
      BASE_COST: 250,
      tax: 'tax',
      mockups: ['220GSMWhite.jpg', '220GSMWhiteB.jpg'],
      texture: '21.png',
      GSM: '220 GSM',
      costStructure:{

        'DTG': {
          logo: 36,
          LessthenA4: 66,
          A4less: 102,
          A4: 90,
          A3: 120,
         full: 150,
        },
        'DTF': {
          logo: 36,
          LessthenA4: 66,
          A4less: 102,
          A4: 90,
          A3: 120,
         full: 150,
        },
      } ,
      clippingRects: {
        front: { left: 530, top: 690, width: 1120, height: 1400 },
        back: { left: 530, top: 690, width: 1120, height: 1400},
      },    
      // print_method: ["DTG Epson", "DTF Epson","DTG Brother"],
      print_method: ["DTG", "DTF"],
      sizeChart:'190-regular.jpg',
      sizes : ['S', 'M', 'L', 'XL', 'XXL']
    },



    // {
    //   id: 3,
    //   name: 'White Oversized T-shirt',
    //   title: 'whot',
    //   images: ['whiteF5.png', '6.png'],
    //   description: 'White Oversized T-shirt',
    //   fabric: '100% Cotton',
    //   BASE_COST: 280,
    //   tax: 'tax',
    //   mockups: ['whiteF5.png', '6.png'],
    //   texture: '21.png',
    //   GSM: '240 GSM',
    //   costStructure: { 
    //     'DTG Brother':{
    //     logo: 60,
    //     LessthenA4: 104,
    //     A4: 130,
    //     A4less: 200,
    //     A3: 200,
    //   full: 250,
    //   }},
    //   clippingRects: {
    //     front: { left: 540, top: 690, width: 1030, height: 1440 },
    //     back: { left: 580, top: 690, width: 1030, height: 1440 },
    //   },
    //   print_method: ["DTG Brother"],
    //   sizeChart:'oversized-tee.jpg',
    //   sizes : ['S', 'M', 'L', 'XL']
    // },


    {
      id: 3,
      name: 'Off White Oversized T-shirt',
      title: 'whot',
      images: ['240GSMOfwhiteFront.jpg', '240GSMOfwhiteBack.jpg'],
      description: 'Off White Oversized T-shirt',
      fabric: '100% French terry cotton',
      BASE_COST: 280,
      tax: 'tax',
      mockups: ['240GSMOfwhiteFront.jpg', '240GSMOfwhiteBack.jpg'],
      texture: '21.png',
      GSM: '240 GSM',
      costStructure: {        
        'DTG': {
          logo: 36,
          LessthenA4: 66,
          A4less: 102,
           A4: 90,
           A3: 120,
          full: 150,
        },
        'DTF': {
          logo: 36,
          LessthenA4: 66,
          A4less: 102,
          A4: 90,
          A3: 120,
         full: 150,
        },
    },
      clippingRects: {
        front: { left: 530, top: 690, width: 1120, height: 1400 },
        back: { left: 530, top: 690, width: 1120, height: 1400},
      },
      print_method: ["DTG", "DTF"],
      sizeChart:'oversized-tee.jpg',
      sizes : ['S', 'M', 'L', 'XL','XXL']
    },

    {
      id: 4,
      name: 'Black Oversized T-shirt',
      title: 'whot',
      images: ['190GSMBlack.jpg', '190GSMBlackB.jpg'],
      description: 'Black Oversized T-shirt',
      fabric: '100% Cotton',
      BASE_COST: 235,
      tax: 'tax',
      mockups: ['190GSMBlack.jpg', '190GSMBlackB.jpg'],
      texture: '21.png',
      GSM: '190 GSM',
      costStructure: {
        'DTG': {
          logo: 60,
          LessthenA4: 90,
          A4less: 138,
          A4: 114,
          A3: 162,
          full: 198,
        },
        'DTF': {
          logo: 36,
          LessthenA4: 66,
          A4less: 102,
          A4: 90,
          A3: 120,
         full: 150,
        },
      },
      clippingRects: {
        front: { left: 540, top: 690, width: 1120, height: 1400 },
          back: { left: 540, top: 690, width: 1120, height: 1400 }
      },
      print_method: ["DTG", "DTF"],
      sizeChart:'190-regular.jpg',
      sizes : ['S', 'M', 'L', 'XL', 'XXL']
    },



  //    {
  //   id: 5,
  //   name: 'Oversized Red T-Shirt',
  //   title: 'whot',
  //   images: ['redFront.jpg', 'redBack.jpg'],
  //   description: 'Oversized Red T-Shirt',
  //   fabric: '100% French terry cotton',
  //   BASE_COST: 280,
  //   tax: 'tax',
  //   mockups: ['redFront.jpg', 'redBack.jpg'],
  //   texture: '21.png',
  //   GSM: '240 GSM',
  //   costStructure: {
  //     'DTG Epson': {
  //       logo: 36,
  //       LessthenA4: 66,
  //       A4less: 102,
  //       A4: 90,
  //       A3: 120,
  //       full: 150
  //     },
  //     'DTF Epson': {
  //       logo: 36,
  //       LessthenA4: 66,
  //       A4less: 102,
  //       A4: 90,
  //       A3: 120,
  //       full: 150
  //     }
  //   },
  //   clippingRects: {
  //     front: { left: 530, top: 690, width: 1120, height: 1400 },
  //     back: { left: 530, top: 690, width: 1120, height: 1400 }
  //   },
  //   print_method: ['DTG Epson', 'DTF Epson'],
  //   sizeChart: 'oversized-tee.jpg',
  //   sizes: ['S', 'M', 'L', 'XL']
  // },


   {
      id: 23,
      name: 'White Oversized T-shirt',
      title: 'whot',
      images: ['White240Front.jpg', 'White240Back.jpg'],
      description: 'White Oversized T-shirt',
      fabric: '100% French terry cotton',
      BASE_COST: 280,
      tax: 'tax',
      mockups: ['White240Front.jpg', 'White240Back.jpg'],
      texture: '21.png',
      GSM: '240 GSM',
      costStructure: {        
        'DTG': {
          logo: 36,
          LessthenA4: 66,
          A4less: 102,
           A4: 90,
           A3: 120,
          full: 150,
        },
        'DTF': {
          logo: 36,
          LessthenA4: 66,
          A4less: 102,
          A4: 90,
          A3: 120,
         full: 150,
        },
    },
      clippingRects: {
        front: { left: 530, top: 690, width: 1120, height: 1400 },
        back: { left: 530, top: 690, width: 1120, height: 1400},
      },
      print_method: ["DTG", "DTF"],
      sizeChart:'oversized-tee.jpg',
      sizes : ['S', 'M', 'L', 'XL','XXL']
    },

  {
    id: 6,
    name: 'Oversized Coffee T-Shirt',
    title: 'whot',
    images: ['coffeeFront.jpg', 'coffeeBack.jpg'],
    description: 'Oversized Coffee T-Shirt',
    fabric: '100% French terry cotton',
    BASE_COST: 280,
    tax: 'tax',
    mockups: ['coffeeFront.jpg', 'coffeeBack.jpg'],
    texture: '21.png',
    GSM: '240 GSM',
    costStructure: {
   'DTG': {
          logo: 60,
          LessthenA4: 90,
          A4less: 138,
          A4: 114,
          A3: 162,
          full: 198,
        },
        'DTF': {
          logo: 36,
          LessthenA4: 66,
          A4less: 102,
          A4: 90,
          A3: 120,
         full: 150,
        },
    },
    clippingRects: {
      front: { left: 530, top: 690, width: 1120, height: 1400 },
      back: { left: 530, top: 690, width: 1120, height: 1400 }
    },
    print_method: ['DTG', 'DTF'],
    sizeChart: 'oversized-tee.jpg',
    sizes: ['S', 'M', 'L', 'XL']
  },
  {
    id: 7,
    name: 'Oversized Royal Blue T-Shirt',
    title: 'whot',
    images: ['royalblueFront.jpg', 'royalblueBack.jpg'],
    description: 'Oversized Royal Blue T-Shirt',
    fabric: '100% French terry cotton',
    BASE_COST: 280,
    tax: 'tax',
    mockups: ['royalblueFront.jpg', 'royalblueBack.jpg'],
    texture: '21.png',
    GSM: '240 GSM',
    costStructure: {
   'DTG': {
          logo: 60,
          LessthenA4: 90,
          A4less: 138,
          A4: 114,
          A3: 162,
          full: 198,
        },
        'DTF': {
          logo: 36,
          LessthenA4: 66,
          A4less: 102,
          A4: 90,
          A3: 120,
         full: 150,
        },
    },
    clippingRects: {
      front: { left: 530, top: 690, width: 1120, height: 1400 },
      back: { left: 530, top: 690, width: 1120, height: 1400 }
    },
    print_method: ['DTG', 'DTF'],
    sizeChart: 'oversized-tee.jpg',
    sizes: ['S', 'M', 'L', 'XL']
  },
  {
    id: 8,
    name: 'Oversized Bottle Green T-Shirt',
    title: 'whot',
    images: ['bottleGreenFront.jpg', 'bottleGreenBack.jpg'],
    description: 'Oversized Bottle Green T-Shirt',
    fabric: '100% French terry cotton',
    BASE_COST: 280,
    tax: 'tax',
    mockups: ['bottleGreenFront.jpg', 'bottleGreenBack.jpg'],
    texture: '21.png',
    GSM: '240 GSM',
    costStructure: {
   'DTG': {
          logo: 60,
          LessthenA4: 90,
          A4less: 138,
          A4: 114,
          A3: 162,
          full: 198,
        },
        'DTF': {
          logo: 36,
          LessthenA4: 66,
          A4less: 102,
          A4: 90,
          A3: 120,
         full: 150,
        },
    },
    clippingRects: {
      front: { left: 530, top: 690, width: 1120, height: 1400 },
      back: { left: 530, top: 690, width: 1120, height: 1400 }
    },
    print_method: ['DTG', 'DTF'],
    sizeChart: 'oversized-tee.jpg',
    sizes: ['S', 'M', 'L', 'XS']
  },


  {
    id: 9,
    name: 'Baby Pink Oversized T-Shirt',
    title: 'whot',
    images: ['pinkFront.jpg', 'pinkBack.jpg'],
    description: 'Baby Pink Oversized T-Shirt',
    fabric: '100% French terry cotton',
    BASE_COST: 280,
    tax: 'tax',
    mockups: ['pinkFront.jpg', 'pinkBack.jpg'],
    texture: '21.png',
    GSM: '240 GSM',
    costStructure: {
   'DTG': {
          logo: 60,
          LessthenA4: 90,
          A4less: 138,
          A4: 114,
          A3: 162,
          full: 198,
        },
        'DTF': {
          logo: 36,
          LessthenA4: 66,
          A4less: 102,
          A4: 90,
          A3: 120,
         full: 150,
        },
    },
    clippingRects: {
      front: { left: 530, top: 690, width: 1120, height: 1400 },
      back: { left: 530, top: 690, width: 1120, height: 1400 }
    },
    print_method: ['DTG', 'DTF'],
    sizeChart: 'oversized-tee.jpg',
    sizes: ['S', 'M', 'L', 'XL', 'XXL']
  },


    {
      id: 10,
      name: 'Black Oversized T-shirt',
      title: 'whot',
      images: ['220GSMBlack.jpg', '220GSMBlackB.jpg'],
      description: 'Black Oversized T-shirt',
      fabric: '100% Cotton',
      BASE_COST: 250,
      tax: 'tax',
      mockups: ['220GSMBlack.jpg', '220GSMBlackB.jpg'],
      texture: '21.png',
      GSM: '220 GSM',
      costStructure: { 
        'DTG': {
          logo: 60,
          LessthenA4: 90,
          A4less: 138,
          A4: 114,
          A3: 162,
          full: 198,
        },
        'DTF': {
          logo: 36,
          LessthenA4: 66,
          A4less: 102,
          A4: 90,
          A3: 120,
         full: 150,
        },
      //   'DTG Brother':{
      //   logo: 60,
      //   LessthenA4: 104,
      //   A4: 175,
      //   A4less: 250,
      //   A3: 250,
      // full: 300,
      // }
    
    },
      clippingRects: {
        front: { left: 530, top: 690, width: 1120, height: 1400 },
        back: { left: 530, top: 690, width: 1120, height: 1400},
      },
      print_method: ["DTG", "DTF"],
      sizeChart:'190-regular.jpg',
      sizes : ['S', 'M', 'L', 'XL', 'XXL']
    },



    {
      id: 11,
      name: 'Black Oversized T-shirt',
      title: 'whot',
      images: ['blackF1.png', '3.png'],
      description: 'Black Oversized T-shirt',
      fabric: '100% French terry cotton',
      BASE_COST: 280,
      tax: 'tax',
      mockups: ['blackF1.png', '3.png'],
      texture: '21.png',
      GSM: '240 GSM',
      costStructure: {        
        'DTG': {
          logo: 60,
          LessthenA4: 90,
          A4less: 138,
          A4: 114,
          A3: 162,
          full: 198,
        },
        'DTF': {
          logo: 36,
          LessthenA4: 66,
          A4less: 102,
          A4: 90,
          A3: 120,
         full: 150,
        },
    },
      clippingRects: {
        front: { left: 510, top: 690, width: 1120, height: 1400 },
        back: { left: 530, top: 690, width: 1120, height: 1400},
      },
      print_method: ["DTG", "DTF"],
      sizeChart:'oversized-tee.jpg',
      sizes : ['S', 'M', 'L', 'XL']
    },


    {
      id: 12,
      name: 'Black Regular Fit T-shirt',
      title: 'wlot',
      images: ['BlackFitF.png', 'BlackFitB.png'],
      description: 'Black Regular Fit T-shirt',
      fabric: '100% Cotton',
      BASE_COST: 180,
      tax: 'tax',
      mockups: ['BlackFitF.png', 'BlackFitB.png'],
      texture: '21.png',
      GSM: '180 GSM',
      costStructure: {
        'DTG': {
          logo: 60,
          LessthenA4: 90,
          A4less: 138,
          A4: 114,
          A3: 162,
          full: 198,
        },
        'DTF': {
          logo: 36,
          LessthenA4: 66,
          A4less: 102,
          A4: 90,
          A3: 120,
         full: 150,
        },
      },
      clippingRects: {
        front: { left: 570, top: 750, width: 1067, height: 1333 },
        back: {  left: 570, top: 750, width: 1067, height: 1333 },
      },
      print_method: ["DTG", "DTF"],
      sizeChart:'regularfit-tee.jpg',
      sizes : ['S', 'M', 'L', 'XL', 'XXL']
    },


    {
      id: 13,
      name: 'White Regular Fit T-shirt',
      title: 'wlot',
      images: ['WhiteFitF.png', 'WhiteFitB.png'],
      description: 'White Regular Fit T-shirt',
      fabric: '100% Cotton',
      BASE_COST: 180,
      tax: 'tax',
      mockups: ['WhiteFitF.png', 'WhiteFitB.png'],
      texture: '21.png',
      GSM: '180 GSM',
      costStructure: {
        'DTG': {
          logo: 36,
          LessthenA4: 66,
          A4less: 102,
           A4: 90,
           A3: 120,
          full: 150,
        },
        'DTF': {
          logo: 36,
          LessthenA4: 66,
          A4less: 102,
          A4: 90,
          A3: 120,
         full: 150,
        },
      },
      clippingRects: {
        front: { left: 570, top: 750, width: 1067, height: 1333 },
        back: {  left: 570, top: 750, width: 1067, height: 1333 },
      },
      print_method: ["DTG", "DTF"],
      sizeChart:'regularfit-tee.jpg',
      sizes : ['S', 'M', 'L', 'XL', 'XXL']
    },

    {
      id: 14,
      name: 'Red Regular Fit T-shirt',
      title: 'wlot',
      images: ['RedFitF.png', 'RedFitB.png'],
      description: 'Red Regular Fit T-shirt',
      fabric: '100% Cotton',
      BASE_COST: 180,
      tax: 'tax',
      mockups: ['RedFitF.png', 'RedFitB.png'],
      texture: '21.png',
      GSM: '180 GSM',
      costStructure: {
        'DTG': {
          logo: 60,
          LessthenA4: 90,
          A4less: 138,
          A4: 114,
          A3: 162,
          full: 198,
        },
        'DTF': {
          logo: 36,
          LessthenA4: 66,
          A4less: 102,
          A4: 90,
          A3: 120,
         full: 150,
        },
      },
      clippingRects: {
        front: { left: 570, top: 750, width: 1067, height: 1333 },
        back: {  left: 570, top: 750, width: 1067, height: 1333 },
      },
      print_method: ["DTG", "DTF"],
      sizeChart:'regularfit-tee.jpg',
      sizes : ['S', 'M', 'L', 'XL', 'XXL']
    },

    {
      id: 15,
      name: 'Navy Blue Regular Fit T-shirt',
      title: 'wlot',
      images: ['NavyBlueFitF.png', 'NavyBlueFitB.png'],
      description: 'Navy Blue Regular Fit T-shirt',
      fabric: '100% Cotton',
      BASE_COST: 180,
      tax: 'tax',
      mockups: ['NavyBlueFitF.png', 'NavyBlueFitB.png'],
      texture: '21.png',
      GSM: '180 GSM',
      costStructure: {
        'DTG': {
          logo: 60,
          LessthenA4: 90,
          A4less: 138,
          A4: 114,
          A3: 162,
          full: 198,
        },
        'DTF': {
          logo: 36,
          LessthenA4: 66,
          A4less: 102,
          A4: 90,
          A3: 120,
         full: 150,
        },
      },
      clippingRects: {
        front: { left: 570, top: 750, width: 1067, height: 1333 },
          back: {  left: 570, top: 750, width: 1067, height: 1333 },
      },
      print_method: ["DTG", "DTF"],
      sizeChart:'regularfit-tee.jpg',
      sizes : ['S', 'M', 'L', 'XL', 'XXL']
    },

    {
      id: 16,
      name: 'Blue Regular Fit T-shirt',
      title: 'wlot',
      images: ['BlueFitF.png', 'BlueFitB.png'],
      description: 'Blue Regular Fit T-shirt',
      fabric: '100% Cotton',
      BASE_COST: 180,
      tax: 'tax',
      mockups: ['BlueFitF.png', 'BlueFitB.png'],
      texture: '21.png',
      GSM: '180 GSM',
      costStructure: {
        'DTG': {
          logo: 60,
          LessthenA4: 90,
          A4less: 138,
          A4: 114,
          A3: 162,
          full: 198,
        },
        'DTF': {
          logo: 36,
          LessthenA4: 66,
          A4less: 102,
          A4: 90,
          A3: 120,
         full: 150,
        },
      },
      clippingRects: {
        front: { left: 570, top: 750, width: 1067, height: 1333 },
        back: {  left: 570, top: 750, width: 1067, height: 1333 },
      },
      print_method: ["DTG", "DTF"],
      sizeChart:'regularfit-tee.jpg',
      sizes : ['S', 'M', 'L', 'XL', 'XXL']
    },

    
    {
      id: 17,
      name: 'Maroon Regular Fit T-shirt',
      title: 'wlot',
      images: ['BrownFitF.png', 'BrownFitB.png'],
      description: 'Maroon Regular Fit T-shirt',
      fabric: '100% Cotton',
      BASE_COST: 180,
      tax: 'tax',
      mockups: ['BrownFitF.png', 'BrownFitB.png'],
      texture: '21.png',
      GSM: '180 GSM',
      costStructure: {
        'DTG': {
          logo: 60,
          LessthenA4: 90,
          A4less: 138,
          A4: 114,
          A3: 162,
          full: 198,
        },
        'DTF': {
          logo: 36,
          LessthenA4: 66,
          A4less: 102,
          A4: 90,
          A3: 120,
         full: 150,
        },
      },
      clippingRects: {
        front: { left: 570, top: 750, width: 1067, height: 1333 },
          back: {  left: 570, top: 750, width: 1067, height: 1333 },
      },
      print_method: ["DTG", "DTF"],
      sizeChart:'regularfit-tee.jpg',
      sizes : ['S', 'M', 'L', 'XL', 'XXL']
    },  


    {
      id: 18,
      name: 'Black Baby Tee',
      title: 'baby',
      images: ['BabyTeeBlackF.jpg','BabyTeeBlackB.jpg'],
      description: 'Baby Tee',
      fabric: '95% cotton and 5% lycra',
      BASE_COST: 205,
      tax: 'tax',
      mockups: ['BabyTeeBlackF.jpg','BabyTeeBlackB.jpg'],
      texture: '21.png',
      GSM: '190 GSM',
      costStructure: {
        'DTG': {
          logo: 60,
          LessthenA4: 90,
          A4: 114,
          full: 130,
        },
        'DTF': {
          logo: 36,
          LessthenA4: 66,
          A4: 90,
          full: 102,
        },
      },
      clippingRects: {
        front: { left: 540, top: 900, width: 1111.3, height: 1333.3 },
        back: { left: 540, top: 800, width: 1111.3, height: 1333.3 },
      },
      print_method: ["DTG", "DTF"],
      sizeChart:'babyTee-SizeChart.jpg',
      sizes : ['XS','S', 'M', 'L', 'XL','XXL']
    },  


    {
      id: 19,
      name: 'White Baby Tee',
      title: 'baby',
      images: ['BabyTeeWhiteF.jpg','BabyTeeWhiteB.jpg' ],
      description: 'Baby Tee',
      fabric: '95% cotton and 5% lycra',
      BASE_COST: 205,
      tax: 'tax',
      mockups: ['BabyTeeWhiteF.jpg','BabyTeeWhiteB.jpg'],
      texture: '21.png',
      GSM: '190 GSM',
      costStructure: {
        'DTG': {
          logo: 36,
          LessthenA4: 66,
          A4: 90,
          full: 102,
        },
        'DTF': {
          logo: 36,
          LessthenA4: 66,
          A4: 90,
          full: 102,
        },
      },
      clippingRects: {
        front: { left: 540, top: 850, width: 1111.3, height: 1333.3 },
        back: { left: 540, top: 800, width: 1111.3, height: 1333.3 },
      },
      print_method: ["DTG", "DTF"],
      sizeChart:'babyTee-SizeChart.jpg',
      sizes : ['XS','S', 'M', 'L', 'XL','XXL']
    },  



    {
      id: 20,
      name: 'Acidwash Oversized T-shirt',
      title: 'whot',
      images: ['AcidWashTee.jpg', 'AcidWashTeeBack.jpg'],
      description: 'Acidwash Oversized T-shirt',
      fabric: '100% French terry cotton',
      BASE_COST: 350,
      tax: 'tax',
      mockups: ['AcidWashTee.jpg', 'AcidWashTeeBack.jpg'],
      texture: '21.png',
      GSM: '240 GSM',
      costStructure: {        
        'DTG': {
          logo: 60,
          LessthenA4: 90,
          A4less: 138,
          A4: 114,
          A3: 162,
          full: 198,
        },
        'DTF': {
          logo: 36,
          LessthenA4: 66,
          A4less: 102,
          A4: 90,
          A3: 120,
         full: 150,
        },
    },
      clippingRects: {
        front: { left: 530, top: 730, width: 1120, height: 1400 },
        back: { left: 530, top: 690, width: 1120, height: 1400},
      },
      print_method: ["DTG", "DTF"],
      sizeChart:'190-regular.jpg',
      sizes : ['S', 'M', 'L', 'XL','XXL']
    },
    

    {
      id: 21,
      name: 'Custom Product',
      title: 'whot',
      images: ['CustomProductFront.PNG', 'CustomProductBack.PNG'],
      description: 'Custom Product',
      fabric: '100% Cotton',
      BASE_COST: 0,
      tax: 'tax',
      mockups: ['CustomProductFront.PNG', 'CustomProductBack.PNG'],
      texture: '21.png',
      GSM: '190 GSM',
      costStructure: {
        'DTG': {
          logo: 60,
          LessthenA4: 90,
          A4less: 138,
          A4: 114,
          A3: 162,
          full: 198,
        },
        'DTF': {
          logo: 36,
          LessthenA4: 66,
          A4less: 102,
          A4: 90,
          A3: 120,
         full: 150,
        },
      },
      clippingRects: {
        front: { left: 484, top: 620, width: 1232, height: 1540 },
        back:  { left: 484, top: 620, width: 1232, height: 1540 }
        
      },
      print_method: ["DTG", "DTF"],
      sizeChart:'',
      sizes : ['S', 'M', 'L', 'XL', 'XXL']
    },



     {
    id: 22,
    name: 'Oversized Maroon T-shirt',
    title: 'whot',
    images: ['MaroonFront.jpg', 'MaroonBack.jpg'],
    description: 'Oversized Maroon T-shirt',
    fabric: '100% French terry cotton',
    BASE_COST: 350,
    tax: 'tax',
    mockups: ['MaroonFront.jpg', 'MaroonBack.jpg'],
    texture: '21.png',
    GSM: '240 GSM',
    costStructure: {
        'DTG': {
          logo: 60,
          LessthenA4: 90,
          A4less: 138,
          A4: 114,
          A3: 162,
          full: 198,
        },
        'DTF': {
          logo: 36,
          LessthenA4: 66,
          A4less: 102,
          A4: 90,
          A3: 120,
         full: 150,
        },
    },
    clippingRects: {
      front: { left: 530, top: 690, width: 1120, height: 1400 },
      back: { left: 530, top: 690, width: 1120, height: 1400 }
    },
    print_method: ['DTG', 'DTF'],
    sizeChart: 'oversized-tee.jpg',
    sizes: ['S', 'M', 'L', 'XL']
  },


    // {
    //   id: 17,
    //   name: 'Cotton Joggers',
    //   title: 'joggers',
    //   images: ['joggersFront.jpg', 'joggersBack.jpg'],
    //   description: 'Premium Cotton Joggers',
    //   fabric: '100% Cotton',
    //   BASE_COST: 570,
    //   tax: 'tax',
    //   mockups: ['joggersFront.jpg', 'joggersBack.jpg'],
    //   texture: '22.png',
    //   GSM: '290 GSM',
    //   productType: 'joggers',
    //   costStructure: {
    //     'DTF Epson': {
    //       logo: 36,
    //       LessthenA4: 66,
    //       A4less: 102,
    //       A4: 90,
    //       A3: 120,
    //      full: 150,
    //     },
    //   },
    //   clippingRects: {
    //     front: [
    //       { left: 560, top: 1150, width: 500, height: 1500 }, // Lower front left
    //       { left: 1150, top: 1150, width: 500, height: 1500 },  // Lower front right
    //       { left: 600, top: 650, width: 400, height: 400 }, // Upper front
    //       { left: 1200, top: 650, width: 400, height: 400 } // Upper front right
    //     ],
    //     back: [
    //       { left: 560, top: 1150, width: 500, height: 1500 }, // Lower front left
    //       { left: 1150, top: 1150, width: 500, height: 1500 },  // Lower front right
    //       { left: 650, top: 400, width: 900, height: 400 }, // Upper front
    //     ]
    //   },
    //   print_method: ["DTF Epson"],
    //   sizeChart: 'joggers-size-chart.jpg',
    //   sizes: ['S', 'M', 'L', 'XL', 'XXL']
    // }
  ];


const STOCK_THRESHOLDS = {
  low: 10,        // <= 10
  moderate: 30,   // 11-30
  good: 60,       // 31-60
  high: 61   // > 60
};

// Product-specific stock thresholds (override default thresholds)
const PRODUCT_STOCK_THRESHOLDS = {
  'White Oversized T-shirt__190 GSM': { low: 5, moderate: 15, good: 40, high: 41 },
  'Black Oversized T-shirt__220 GSM': { low: 8, moderate: 25, good: 50, high: 51 },
  'Custom Product__190 GSM': { low: 2, moderate: 10, good: 30, high: 31 },
  // Add more product-specific thresholds as needed
};

const getStockStatus = (totalStock, productKey) => {
  // Use product-specific thresholds if available, otherwise use default
  const thresholds = PRODUCT_STOCK_THRESHOLDS[productKey] || STOCK_THRESHOLDS;
  
  if (totalStock <= thresholds.low) return { label: 'Low Stock', color: '#e74c3c' };
  if (totalStock <= thresholds.moderate) return { label: 'Moderate Stock', color: '#f39c12' };
  if (totalStock <= thresholds.good) return { label: 'Good Stock', color: '#27ae60' };
  return { label: 'Excellent Stock', color: '#2980ef' };
};

const SelectProduct = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const shop = queryParams.get('shop');
  const state = location.state;
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [inventory, setInventory] = useState([]);
  const [stockMap, setStockMap] = useState({});

  const user = auth.currentUser;
  if (!user) {
    throw new Error("User not logged in");
  }

  useEffect(() => {
    // Fetch inventory data on mount
    axios.get('https://ufb-1.onrender.com/api/inventory/')
      .then(res => {
        setInventory(res.data);
      })
      .catch(err => {
        console.error('Error fetching inventory:', err);
      });
  }, []);

  useEffect(() => {
    // Aggregate stock by product name + GSM
    const map = {};
    inventory.forEach(item => {
      const key = `${item.productName}__${item.gsm}`;
      const stockBySize = item.stockBySize || {};
      const totalStock = Object.values(stockBySize).reduce((sum, qty) => sum + (Number(qty) || 0), 0);
      if (!map[key]) map[key] = 0;
      map[key] += totalStock;
    });
    setStockMap(map);
  }, [inventory]);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  // Filter products based on selected t-shirt ID
  let filteredProducts = [];

  if (state?.id === 1) {
    filteredProducts = products.filter(product => product.title === 'whot');
  // } else if (state?.id === 2) {
  //   filteredProducts = products.filter(product => product.title === 'blot');
  } else if (state?.id === 2) {
    filteredProducts = products.filter(product => product.title === 'wlot');
  } else if (state?.id === 3) {
    filteredProducts = products.filter(product => product.title === 'baby');
  }else if (state?.id === 4) {
      filteredProducts = products.filter(product => product.title === 'joggers');
  } else {
    filteredProducts = products; // default to show all if no ID is provided
  }


  if (user.uid !== 'xKYZZ6G648Ru6E0lK7xNnhEXpM93') {
    filteredProducts = filteredProducts.filter(product => product.id !== 21);
  }

    if (user.uid !== '6Q1cEoMrjRXbzBMQzfwFeZWHi102') {
    filteredProducts = filteredProducts.filter(product => product.id !== 22);
  }

  // if (user.uid !== 'CrQeQiv7iDPcP4HDzpsaeiNscDJ3') {
  //   filteredProducts = filteredProducts.filter(product => product.id !== 16);
  // }


  const handleProductClick = (product) => {
    // Check if the product is joggers and route accordingly
    if (product.productType === 'joggers') {
      navigate('/DesignJoggers', { 
        state: { 
          product, 
          costStructure: product.costStructure, 
          BASE_COST: product.BASE_COST, 
          name: product.name, 
          GSM: product.GSM, 
          tax: product.tax,
          clippingRects: product.clippingRects, 
          sizeChart: product.sizeChart, 
          print_method: product.print_method, 
          sizes: product.sizes 
        } 
      });
    } else {
      // Default route for t-shirts and other products
      navigate('/DesignUpload', { 
        state: { 
          product, 
          costStructure: product.costStructure, 
          BASE_COST: product.BASE_COST, 
          name: product.name, 
          GSM: product.GSM, 
          tax: product.tax,
          clippingRects: product.clippingRects, 
          sizeChart: product.sizeChart, 
          print_method: product.print_method, 
          sizes: product.sizes 
        } 
      });
    }
  };
  // const handleProductClick = (product) => {
 
        
  //     navigate('/DesignUpload', { state: { product, costStructure: product.costStructure, BASE_COST: product.BASE_COST, name: product.name, GSM: product.GSM , tax: product.tax,clippingRects: product.clippingRects, sizeChart: product.sizeChart, print_method: product.print_method, sizes:product.sizes } });
  
  // };

  return (
    <div className="dashboard">
      <Header />
      <div className="dashboard-container">
        <Sidebar />
        <div className="main-content">
          <div className="product-list">
            {filteredProducts.map((product) => {
              const key = `${product.name}__${product.GSM}`;
              const totalStock = stockMap[key];
              
              // If product is not in inventory, show 'High Stock'
              if (totalStock === undefined) {
                return (
                  <div
                    key={product.id}
                    className="product-card"
                    onClick={() => handleProductClick(product)}
                    style={{ position: 'relative' }}
                  >
                    {/* High Stock indicator for products not in inventory */}
                    <div style={{
                      position: 'absolute',
                      top: 10,
                      right: 10,
                      display: 'flex',
                      alignItems: 'center',
                      zIndex: 2
                    }}>
                      <span style={{
                        display: 'inline-block',
                        width: 12,
                        height: 12,
                        borderRadius: '50%',
                        background: '#04d604',
                        marginRight: 6,
                        border: '1px solid #ccc'
                      }} />
                      <span className="stock-status-text" style={{ fontSize: 12, color: '#04d604' }}>Always in Stock</span>
                    </div>
                    <img src={product.images[0]} alt={product.name} className="product-image" />
                    <p className="product-description">{product.description}</p>
                    <p className="product-description">{product.fabric}</p>
                    <p className="product-description">Base Cost: ₹{product.BASE_COST} + {product.tax} </p>
                    <p className="product-description">{product.GSM}</p>
                  </div>
                );
              }
              
              // Use conditional thresholds for products in inventory
              const stockStatus = getStockStatus(totalStock, key);
              return (
                <div
                  key={product.id}
                  className="product-card"
                  onClick={() => handleProductClick(product)}
                  style={{ position: 'relative' }}
                >
                  {/* Stock indicator */}
                  <div style={{
                    position: 'absolute',
                    top: 10,
                    right: 10,
                    display: 'flex',
                    alignItems: 'center',
                    zIndex: 2
                  }}>
                    <span style={{
                      display: 'inline-block',
                      width: 12,
                      height: 12,
                      borderRadius: '50%',
                      background: stockStatus.color,
                      marginRight: 6,
                      border: '1px solid #ccc'
                    }} />
                    <span className="stock-status-text" style={{ fontSize: 12, color: stockStatus.color }}>{stockStatus.label}</span>
                  </div>
                  <img src={product.images[0]} alt={product.name} className="product-image" />
                  <p className="product-description">{product.description}</p>
                  <p className="product-description">{product.fabric}</p>
                  <p className="product-description">Base Cost: ₹{product.BASE_COST} + {product.tax} </p>
                  <p className="product-description">{product.GSM}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectProduct;



// const SelectProduct = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const queryParams = new URLSearchParams(location.search);
//   const shop = queryParams.get('shop');
//   const state = location.state;
//   const [isSidebarOpen, setIsSidebarOpen] = useState(false);

//   const toggleSidebar = () => {
//     setIsSidebarOpen(!isSidebarOpen);
//   };

//   const filteredProducts = state?.color
//     ? products.filter(product =>
//         (state.color === 'white' && product.title === 'whot') ||
//         (state.color === 'black' && product.title === 'blot')
//       )
//     : products;

//   const handleProductClick = (product) => {
//     if (shop) {
//       navigate(`/DesignUpload?shop=${encodeURIComponent(shop)}`, {
//         state: {
//           product,
//           costStructure: product.costStructure,
//           BASE_COST: product.BASE_COST,
//           name: product.name,
//           GSM: product.GSM,
//           tax: product.tax,
//           images: product.images, // Pass the mockup images
//         }
//       });
//     } else {
//       console.error('Shop parameter is missing');
//     }
//   };

//   return (
//     <div className="dashboard">
//       <Header />
//       <div className="dashboard-container">
//         <Sidebar />
//         <div className="main-content">
//           <div className="product-list">
//             {filteredProducts.map((product) => (
//               <div
//                 key={product.id}
//                 className="product-card"
//                 onClick={() => handleProductClick(product)}
//               >
//                 {product.images.map((images, index) => (
//                   <img
//                     key={index}
//                     src={images}
//                     alt={`${product.name} images ${index + 1}`}
//                     className="product-image"
//                   />
//                 ))}
//                 <p className="product-description">{product.description}</p>
//                 <p className="product-description">{product.fabric}</p>
//                 <p className="product-description">
//                   Base Cost: ₹{product.BASE_COST} + {product.tax}
//                 </p>
//                 <p className="product-description">{product.GSM}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SelectProduct;